/**
 * Model object to store information related to Pricing of Itinerary
 */
class PricingInfoObj {
  constructor() {
    this.rawData = null
    this.ticketingAirline = ''
    this.ticketingFeeMayApply = false
    this.currencyCode = 'USD'
    this.baseFare = 0.0
    this.insuranceCost = 0.0
    this.feeList = []
    this.ticketingFeeList = []
    this.totalTaxes = 0.0
    this.totalFare = 0.0
    this.priceChanged = false
    this.priceHigher = false
    this.fareInfo = []
    this.comparativeRetailPrice = null
    this.componentItinPricingInfo = []
    this.fareRuleSubSection = []
  }

  getRawData() {
    return this.rawData
  }

  setRawData(rawData) {
    this.rawData = rawData
  }

  getTicketingAirline() {
    return this.ticketingAirline
  }

  setTicketingAirline(ticketingAirline) {
    this.ticketingAirline = ticketingAirline
  }

  isTicketingFeeMayApply() {
    return this.ticketingFeeMayApply
  }

  setTicketingFeeMayApply(ticketingFeeMayApply) {
    this.ticketingFeeMayApply = ticketingFeeMayApply
  }

  getCurrencyCode() {
    return this.currencyCode
  }

  setCurrencyCode(currencyCode) {
    this.currencyCode = currencyCode
  }

  getBaseFare(numPassengers = 1) {
    return this.baseFare * numPassengers
  }

  setBaseFare(baseFare) {
    this.baseFare = baseFare
  }

  getInsuranceCost(numPassengers = 1) {
    return this.insuranceCost ? this.insuranceCost * numPassengers : 0
  }

  setInsuranceCost(insuranceCost) {
    this.insuranceCost = insuranceCost
  }

  getFeeList() {
    return this.feeList
  }

  addFee(fee) {
    this.feeList.push(fee)
  }

  getTicketingFeeList() {
    return this.ticketingFeeList
  }

  addTicketingFeeList(ticketingFee) {
    this.ticketingFeeList.push(ticketingFee)
  }

  getTotalTaxes(numPassengers = 1) {
    return this.totalTaxes * numPassengers
  }

  setTotalTaxes(totalTaxes) {
    this.totalTaxes = totalTaxes
  }

  getTotalFare(numPassengers = 1) {
    return this.totalFare * numPassengers
  }

  setTotalFare(totalFare) {
    this.totalFare = totalFare
  }

  getFareRuleSubSection() {
    return this.fareRuleSubSection
  }

  setFareRuleSubSection(fareRuleSubSection) {
    this.fareRuleSubSection = fareRuleSubSection
  }

  isPriceChanged() {
    return this.priceChanged
  }

  setPriceChanged(priceChanged) {
    this.priceChanged = !!priceChanged
  }

  isPriceHigher() {
    return this.priceHigher
  }

  setPriceHigher(priceHigher) {
    this.priceHigher = !!priceHigher
  }

  setFareInfo(pricingInfo) {
    this.fareInfo = pricingInfo
  }

  getFareInfo() {
    return this.fareInfo
  }

  setComparativeRetailPrice(comparativeRetailPrice) {
    this.comparativeRetailPrice = comparativeRetailPrice
  }

  getComparativeRetailPrice(numPassengers = 1) {
    return this.comparativeRetailPrice * numPassengers
  }

  addComponentItinPricingInfo(componentItinPricingInfo) {
    let pricingInfo
    if (componentItinPricingInfo) {
      pricingInfo = new PricingInfoObj()
      pricingInfo.update(componentItinPricingInfo)
      this.componentItinPricingInfo.push(pricingInfo)
    }
  }

  getComponentItinPricingInfo() {
    return this.componentItinPricingInfo
  }

  getProcessingFee() {
    let processingFee = 0.0
    const feeList = this.getFeeList()

    for (let i = 0; i < feeList.length; i++) {
      if (feeList[i].feeCode.match(/offer/gi)) {
        processingFee = feeList[i].amount
      }
    }

    return processingFee
  }

  update(rawPricingInfo, priceChanged, priceHigher) {
    if (rawPricingInfo) {
      this.setRawData(rawPricingInfo)
    }

    if (this.rawData) {
      this.setTicketingAirline(this.rawData.ticketingAirline)

      // this.setTicketingFeeMayApply(this.rawData);
      this.setCurrencyCode(this.rawData.currencyCode)
      this.setBaseFare(this.rawData.baseFare || this.rawData.candidatePrice)
      this.setInsuranceCost(this.rawData.insuranceCost)
      this.setFareInfo(this.rawData.fareInfo)
      this.setFareRuleSubSection(this.rawData.fareRuleSubSection)

      if (this.rawData.fees && this.rawData.fees.length) {
        for (let i = 0; i < this.rawData.fees.length; i++) {
          this.addFee(this.rawData.fees[i])
        }
      }

      if (this.rawData.ticketingFee && this.rawData.ticketingFee.length) {
        for (let i = 0; i < this.rawData.ticketingFee.length; i++) {
          this.addTicketingFeeList(this.rawData.ticketingFee[i])
        }
      }

      this.setTotalTaxes(this.rawData.totalTaxes)
      this.setTotalFare(this.rawData.totalFare || this.rawData.totalTripCost)

      this.setPriceChanged(priceChanged)
      this.setPriceHigher(priceHigher)

      if (this.rawData.comparativeRetailPrice) {
        this.setComparativeRetailPrice(this.rawData.comparativeRetailPrice)
      }

      if (this.rawData.componentItinPricingInfo) {
        this.rawData.componentItinPricingInfo.forEach(componentPricingInfo => {
          this.addComponentItinPricingInfo(componentPricingInfo)
        })
      }
    }
  }
}

export { PricingInfoObj }
